<script setup lang="ts">
  import { Text } from "@ui-kit";
  import { Image } from "@src/components";

  const { image, name, article, color } = defineProps<{
    image: string;
    name: string;
    article: string;
    color: string;
  }>();
</script>

<template>
  <div class="item">
    <div class="item__content">
      <div class="item__image">
        <Image :url="image" />
      </div>
      <div class="item__info">
        <Text font="body-medium-16" :wrap="false">{{ article }}</Text>
        <Text font="body-regular-14" color="secondary" :wrap="false">{{ color }}, {{ name }}</Text>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .item {
    display: flex;
    width: 100%;
    overflow: hidden;
    flex-shrink: 0;
    border-radius: 16px;
    background-color: var(--sf-base-background-white);
  }

  .item__content {
    display: flex;
    flex: 1;
    gap: 12px;
    padding: 12px;
    align-items: center;
    overflow: hidden;
  }

  .item__image {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    width: 50px;
    height: 56px;
    overflow: hidden;
    border-radius: 8px;
  }

  .item__info {
    display: flex;
    flex-direction: column;
    gap: 4px;
    overflow: hidden;
  }

  .item__info :deep(.text) {
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>
